// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"9d39b520","86":"972c6b8a","219":"7ab538fd","347":"1b7fc623","661":"403e1de4","665":"5fc5c3be","722":"3c3f21b9","734":"2e50646f","786":"85ddfd59","849":"ce0cece5","930":"872c39e3","963":"52b642c5"}[chunkId] + ".chunk.js";
};